import styled from 'styled-components';
import '../../styles/GlobalThemeStyle';
import { Card, Table, Button, Modal, Progress } from 'antd';
import Lottie from 'lottie-react';

export const XThemeLottie = styled(Lottie)`
	position: relative;
	background: transparent;
	width: 100%;
`;

export const XTheme2Para1 = styled.p`
	width: 100%;
	position: relative;
	margin: 0px;
	font-weight: 400;
	font-size: 14px;
	line-height: 14px;
	letter-spacing: -0.02em;
	color: ${({ theme }) => theme.CQColors.themeColor3};
`;

export const ThemedProgress = styled(Progress).attrs(({ theme }) => ({
	strokeColor: {
		'0%': '#0E4C88',
		'100%': '#067EF1',
	},
	trailColor: '#F9F9F9',
}))`
	margin-bottom: 10px;
`;

export const XTheme2StepCount = styled.p`
	width: 100%;
	position: relative;
	margin: 0px;
	font-weight: 500;
	font-size: 14px;
	line-height: 24px;
	letter-spacing: -0.02em;
	color: ${({ theme }) => theme.CQColors.secondaryColor};
`;

export const XTheme2StepTitle = styled.p`
	width: 100%;
	position: relative;
	margin: 0px;
	font-weight: 500;
	font-size: 20px;
	line-height: 28px;
	letter-spacing: -0.02em;
	color: ${({ theme }) => theme.CQColors.primaryColor};
`;

export const XTheme2StepSubTitle = styled.p`
	width: 100%;
	position: relative;
	margin: 0px;
	font-weight: 400;
	font-size: 16px;
	line-height: 28px;
	letter-spacing: -0.02em;
	color: ${({ theme }) => theme.CQColors.primaryColor};
`;
// End new theme style components
